import React from 'react'
import ReactPlayer from 'react-player'


export default class CameraPanelContent extends React.Component {

  constructor(props) {
    super(props)
    
    this.update = this.update.bind(this)
    this.state = {
      date: '',
      deviceId: localStorage.getItem('activeDeviceId')
    }
  }
  

  componentDidMount() {
    this.intervalId = window.setInterval(this.update, 1000)

  }

  componentWillUnmount() {
    window.clearInterval(this.intervalId)
  }

  update() {
    this.setState({
      date: new Date().toLocaleString()
    })
  }

  render() {
    const { date, deviceId } = this.state
    return (
      <div>
        device: {deviceId}                
        <ReactPlayer 
            url={`/video/${deviceId}.mp4`}
            width="480px"
            playing
            controls
        />
      </div>
    )
  }
}